module.exports = __webpack_public_path__ + "images/mantel94330fe22f7efaabc819d777336fe626.png";